"use strict";
/** @iotv/datamodel should not be dependent on @iotv/payload-definition which exports deviceEnabled types, this aims to infer from class inheritence from DeviceEnabledType */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceEnabledTypesMap = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const getDeviceEnabledTypesMap = (ModelClasses) => {
    const deviceEnabledClassNames = Object.fromEntries(Object.entries(ModelClasses).map(([k, clazz]) => {
        let res = [k, null];
        try {
            if (typeof clazz === 'function') {
                const x = clazz;
                const xInstance = new x({});
                res[1] = xInstance instanceof datamodel_core_1.DeviceEnabledType;
            }
            else {
                res[1] = 'not model type';
            }
        }
        catch (e) {
            res[1] = e.message;
        }
        return res;
    }));
    return deviceEnabledClassNames;
};
exports.getDeviceEnabledTypesMap = getDeviceEnabledTypesMap;
